var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.editable
      ? _c("div", {
          staticClass: "cms-content",
          domProps: { innerHTML: _vm._s(_vm.content) },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.edit()
            }
          }
        })
      : _c("div", {
          staticClass: "cms-content",
          domProps: { innerHTML: _vm._s(_vm.content) }
        }),
    _vm._v(" "),
    _vm.editable && _vm.modalOpened
      ? _c(
          "div",
          {
            ref: "modal",
            staticClass: "modal fade",
            attrs: { tabindex: "-1", role: "dialog" }
          },
          [
            _c(
              "div",
              { staticClass: "modal-dialog", attrs: { role: "document" } },
              [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c("h4", { staticClass: "modal-title" }, [
                      _vm._v("Edit Content - " + _vm._s(this.name))
                    ]),
                    _vm._v(" "),
                    _vm._m(0)
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-body" },
                    [
                      _c("editor", {
                        attrs: { init: _vm.editorOptions },
                        model: {
                          value: _vm.editing,
                          callback: function($$v) {
                            _vm.editing = $$v
                          },
                          expression: "editing"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.close()
                          }
                        }
                      },
                      [_vm._v("Close")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.save()
                          }
                        }
                      },
                      [_vm._v("Save changes")]
                    )
                  ])
                ])
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e03bcfc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e03bcfc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/cms.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7e03bcfc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/cms.vue
// module chunks = 0